import { Paper } from '@mui/material'
import { AnnouncementList } from '../announcements/AnnouncementList'
import { useEvent } from '../events/EventContext'
import { SectionPage } from '../events/SectionPage'

export function AnnouncementsPage() {
  const { event } = useEvent()
  return (
    <SectionPage title="Annonces">
      <Paper variant="outlined" sx={{ p: 2 }}>
        <AnnouncementList slug={event.slug} timezone={event.timezone} role={event.role} />
      </Paper>
    </SectionPage>
  )
}
